/* istanbul ignore file */
import React from 'react';
import { Button, ButtonColor, ButtonSize, FormButtonLayoutProps } from 'ui-builder';

function CancelButtonLayout(props: FormButtonLayoutProps) {
  return (
    <Button
      text={props.text}
      onClick={props.onClick}
      color={ButtonColor.RED}
      size={ButtonSize.BIG}
    />
  );
}

export default CancelButtonLayout;
